import { Component, Input, OnInit } from "@angular/core";
import moment from "moment-timezone";
import { ConfirmationService } from "primeng/api";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { EGiftCardPool } from "src/app/shared/models/eGift/EGiftCardPool.model";
import { EGiftVenue } from "src/app/shared/models/eGift/EGiftVenue.model";

@Component({
	selector: "app-e-gift-card-pool-setup",
	templateUrl: "./e-gift-card-pool-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class EGiftCardPoolSetupComponent implements OnInit {
	@Input() eGiftVenue: EGiftVenue;

	addType: string;

	cardPool: EGiftCardPool[];

	duplicateRejectPool: string[] = [];

	moment: any = moment;
	multiButton = [
		{
			label: "Add by range",
			command: () => {
				this.addType = "range";
			},
		},
		{
			label: "Add individually",
			command: () => {
				this.addType = "array";
			},
		},
		{
			label: "Import",
			command: () => {
				document.getElementById("importFileTwo").click();
			},
		},
	];

	newCardPool: string[] = [];
	newCardNumber: number;
	newStartingNumber: number;
	newEndingNumber: number;

	constructor(public app: AppService, private focuslink: FocuslinkService, private confirmation: ConfirmationService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {
		this.init();
	}

	async init() {
		await this.getEGiftCardPool(this.venueSvc.venueKey);
	}

	addNewCardToPool(cardNumber) {
		if (cardNumber < 1000000000) {
			this.app.msgSvc.add({ severity: "warn", detail: "Card number must be at least 10 digits" });
			return;
		}
		if (!this.newCardPool.some((i) => i === cardNumber)) {
			this.newCardPool.push(cardNumber);
		} else {
			this.app.msgSvc.add({ severity: "warn", detail: "Card number already exists in list." });
			this.newCardNumber = undefined;
			return;
		}
		this.newCardNumber = undefined;
	}

	async getEGiftCardPool(venueKey) {
		const resp = await this.focuslink.eGiftCardPoolGet(venueKey);
		this.cardPool = resp.map((i) => {
			return new EGiftCardPool(i);
		});
	}

	async eGiftCardPoolPostRange(startingNumber: number, endingNumber: number) {
		this.app.loading(true);
		this.addType = undefined;
		const resp = await this.focuslink.eGiftCardPoolPostRange(this.venueSvc.venueKey, startingNumber, endingNumber);
		this.cardPool = resp.map((i) => {
			return new EGiftCardPool(i);
		});
		this.app.loading(false);
	}

	async eGiftCardPoolPostArray() {
		this.app.loading(true);
		this.addType = undefined;
		const cardPoolArray: EGiftCardPool[] = [];
		this.newCardPool.forEach((i) => {
			cardPoolArray.push(
				new EGiftCardPool({
					cardNumber: i.toString(),
				})
			);
		});

		const resp = await this.focuslink.eGiftCardPoolPostArray(this.venueSvc.venueKey, cardPoolArray);
		this.cardPool = resp.map((i) => {
			return new EGiftCardPool(i);
		});
		this.app.loading(false);
	}

	async eGiftCardPoolDelete(cardNumber: string) {
		this.confirmation.confirm({
			message: `Are you sure you want to delete ${cardNumber} from the Pool?`,
			accept: async () => {
				const resp = await this.focuslink.eGiftCardPoolDelete(this.venueSvc.venueKey, cardNumber);
				const idx = this.cardPool.findIndex((i) => i.cardNumber === cardNumber);
				this.cardPool.splice(idx, 1);
			},
			reject: async () => {
				this.confirmation.close();
			},
		});
	}

	importFileUpload(event) {
		const file: File = event.target.files[0];
		if (file) {
			let cards;
			let fileReader = new FileReader();
			fileReader.onload = (e) => {
				cards = fileReader.result;
				const cardArray: string[] = cards.split("\n");

				this.newCardPool = [];
				for (let card of cardArray) {
					if (card) {
						card = card.replace("\r", "");

						if (!this.cardPool.some((i) => i.cardNumber === card)) {
							this.newCardPool.push(card.trim());
						} else {
							this.duplicateRejectPool.push(card);
						}
					}
				}
				this.eGiftCardPoolPostArray();

				this.app.msgSvc.add({ severity: "success", detail: `${this.newCardPool.length} cards added to pool.` });
			};
			fileReader.readAsText(file);
		}
	}
}
